// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-file.page.title': 'Files',
    'team-member-file.page.search_results': 'Search Results',
    'team-member-file.page.create.title': 'Create New File',
    'team-member-csv.page.import.title': 'Import Team Members',
    'team-member-file.page.search.title': 'Find Files',
    'team-member-file.page.edit.title': 'Edit File',
    'team-member-file.page.view.title': 'View File',
    'team-member-file.page.all': 'All',

    'team-member-file.button.cancel': 'Cancel',
    'team-member-file.button.select': 'Select',
    'team-member-file.button.find': 'Find Files',
    'team-member-file.button.search': 'Apply',
    'team-member-file.button.create': 'Upload File',
    'team-member-csv.button.import': 'Import',
    'team-member-file.button.new': 'New File',
    'team-member-file.button.save': 'Save Changes',
    'team-member-file.button.delete': 'Permanently Delete',
    'team-member-file.button.edit': 'Edit',
    'team-member-file.button.restore': 'Restore',
    'team-member-file.button.reset': 'Reset',

    'team-member-file.placeholder.search': 'Search files',

    'team-member-file.link.create_first_team_member_file': 'Click here to upload your first file',
    'team-member-file.link.team_member_files': ' Return to Files',
    'team-member-file.link.retry': 'Click here to retry',

    'team-member-file.checkbox.all': 'Check All',
    'team-member-file.checkbox.actions_label': 'with selected',

    'team-member-file.label.team_member_name': 'Team Member',

    'team-member-file.label.upload': 'Click to upload or drag and drop',
    'team-member-file.label.upload_types': 'PDF,JPG,PNG,JPEG',

    'team-member-file.label.file': 'File',
    'team-member-file.label.original_file_name': 'Original File Name',

    'team-member-file.label.file_path': 'File Path',

    'team-member-file.label.from__file_size': 'From file size',
    'team-member-file.label.to__file_size': 'To file size',
    'team-member-file.label.file_size': 'File Size',

    'team-member-file.label.file_mime_type': 'File Mime Type',

    'team-member-file.label.from__created_at': 'From created at',
    'team-member-file.label.to__created_at': 'To created at',
    'team-member-file.label.created_at': 'Created At',

    'team-member-file.label.from__updated_at': 'From updated at',
    'team-member-file.label.to__updated_at': 'To updated at',
    'team-member-file.label.updated_at': 'Updated At',

    'team-member-file.label.from__deleted_at': 'From deleted at',
    'team-member-file.label.to__deleted_at': 'To deleted at',
    'team-member-file.label.deleted_at': 'Deleted At',

    'team-member-file.label.status': 'Status',

    'team-member-file.sort.field_label': 'Field',
    'team-member-file.sort.direction_label': 'Direction',
    'team-member-file.sort.direction_ascending': 'Ascending',
    'team-member-file.sort.direction_descending': 'Descending',

    'team-member-file.modal.title.team_member_file_delete_permanently': 'Delete File',
    'team-member-file.modal.title.team_member_file_restore': 'Restore File',

    'team-member-file.modal.message.team_member_file_delete_permanently':
        'Are you sure that you want to permanently delete this file? This action cannot be undone. | Are you sure that you want to permanently delete these files? This action cannot be undone.',
    'team-member-file.modal.message.team_member_file_restore': 'Are you sure that you want to restore this file? | Are you sure that you want to restore these files?',

    'team-member-file.success.message.team_member_file_created': 'Your file has been created',
    'team-member-file.success.message.team_member_file_updated': 'Your file has been updated',
    'team-member-file.success.message.team_member_file_restored': 'Your file has been restored | All selected files were restored',
    'team-member-file.success.message.team_member_file_deleted': 'Your file has been permanently deleted | All selected files were permanently deleted',

    'team-member-file.error.message.team_member_file_deleted': 'This file was already permanently deleted | These files were already permanently deleted',
    'team-member-file.error.message.team_member_file_restored': 'This file was already restored | These files were already restored',
    'team-member-file.error.message.error_loading_page': 'Sorry, there was an error loading file.| Sorry, there was an error loading files.',
};
